export default __webpack_public_path__ + "static/media/contactsGreen.4e6c762b.svg";